import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['elementToClick']

  click(event) {
    this.elementToClickTarget.click();
  }
}